const mathClasses = [
  {
    key: 0,
    tooltip: "College Algebra and Trigonometry",
    label: "MTH 123",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/100/MTH-123",
  },
  {
    key: 1,
    tooltip: "Discrete Mathematical Structures for Computer Science",
    label: "MTH 228",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-228",
  },
  {
    key: 2,
    tooltip: "Calculus Computer Laboratory",
    label: "MTH 229",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-229",
  },
  {
    key: 3,
    tooltip: "Calculus I with Pre-Calculus",
    label: "MTH 230",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-230",
  },
  {
    key: 4,
    tooltip: "Analytic Geometry and Calculus I",
    label: "MTH 231",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-231",
  },
  {
    key: 5,
    tooltip: "Calculus II",
    label: "MTH 232",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-232",
  },
];

const mathProfileClasses = [
  {
    key: 0,
    tooltip: "College Algebra and Trigonometry",
    label: "MTH 123",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/100/MTH-123",
  },
  {
    key: 1,
    tooltip: "Calculus I with Pre-Calculus",
    label: "MTH 230 & 229",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-230",
  },
  {
    key: 2,
    tooltip: "Analytic Geometry and Calculus I",
    label: "MTH 231 & 229",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-231",
  },
  {
    key: 3,
    tooltip: "Calculus II",
    label: "MTH 232",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/MTH-Mathematics/200/MTH-232",
  },
];

const cscClasses = [
  {
    key: 0,
    tooltip: "Introduction to Computer Science",
    label: "CSC 126",
    url: "https://csicuny.smartcatalogiq.com/current/Undergraduate-Catalog/Courses/CSC-Computer-Science/100/CSC-126",
  },
  {
    key: 1,
    tooltip: "Intermediate Programming",
    label: "CSC 211",
    url: "https://csicuny.smartcatalogiq.com/en/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-211",
  },
  {
    key: 2,
    tooltip: "Computers, Networking and Security",
    label: "CSC 220",
    url: "https://csicuny.smartcatalogiq.com/en/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-220",
  },
  {
    key: 3,
    tooltip: "Discrete Mathematical Structures for Computer Science",
    label: "CSC 228",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-228",
  },
  {
    key: 4,
    tooltip: "Operating Systems Programming Laboratory",
    label: "CSC 305",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-305",
  },
  {
    key: 5,
    tooltip: "Introduction to Database Systems",
    label: "CSC 315",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-315",
  },
  {
    key: 6,
    tooltip: "Data Structures",
    label: "CSC 326",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-326",
  },
  {
    key: 7,
    tooltip: "Object-Oriented Software Design",
    label: "CSC 330",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-330",
  },
  {
    key: 8,
    tooltip: "Operating Systems I",
    label: "CSC 332",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-332",
  },
  {
    key: 9,
    tooltip: "Digital Circuits Design",
    label: "CSC 346",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-346",
  },
  {
    key: 10,
    tooltip: "Digital Circuits Laboratory",
    label: "CSC 347",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-347",
  },
  {
    key: 11,
    tooltip: "Analysis of Algorithms",
    label: "CSC 382",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-382",
  },
  {
    key: 12,
    tooltip: "Software Engineering",
    label: "CSC 430",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-430",
  },
  {
    key: 13,
    tooltip: "Computer Architecture",
    label: "CSC 446",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-446",
  },
  {
    key: 14,
    tooltip: "Seminar in Computer Science",
    label: "CSC 490",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-490",
  },
];

const cscElectives = [
  {
    key: 0,
    tooltip: "Computer Hacking Revealed",
    label: "CSC 223",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-223",
  },
  {
    key: 1,
    tooltip: "Introduction to Web Development and the Internet",
    label: "CSC 225",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-225",
  },
  {
    key: 2,
    tooltip: "Web Database Applications",
    label: "CSC 226",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-226",
  },
  {
    key: 3,
    tooltip: "Introductory Computer Game Programming",
    label: "CSC 227",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-227",
  },
  {
    key: 4,
    tooltip: "Introduction to High Performance Computing",
    label: "CSC 229",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-229",
  },
  {
    key: 5,
    tooltip: "Robotic Explorations",
    label: "CSC 235",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-235",
  },
  {
    key: 6,
    tooltip: "Introduction to Data Science",
    label: "CSC 245",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-245",
  },
  {
    key: 7,
    tooltip: "Serious Game Development",
    label: "CSC 250",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-250",
  },
  {
    key: 8,
    tooltip: "Machine Learning and Knowledge Discovery",
    label: "CSC 412",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-412",
  },
  {
    key: 9,
    tooltip: "Concepts of Programming Languages",
    label: "CSC 420",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-420",
  },
  {
    key: 10,
    tooltip: "Internet Data Communications",
    label: "CSC 421",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-421",
  },
  {
    key: 11,
    tooltip: "Advanced Database Management Systems",
    label: "CSC 424",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-424",
  },
  {
    key: 12,
    tooltip: "Shared Memory Parallel Computing",
    label: "CSC 425",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-425",
  },
  {
    key: 13,
    tooltip: "Applied Cryptography",
    label: "CSC 426",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-426",
  },
  {
    key: 14,
    tooltip: "Advanced Computer Game Programming",
    label: "CSC 427",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-427",
  },
  {
    key: 15,
    tooltip: "Advanced High Performance Computing",
    label: "CSC 429",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-429",
  },
  {
    key: 16,
    tooltip: "Operating Systems II",
    label: "CSC 432",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-432",
  },
  {
    key: 17,
    tooltip: "Compiler Construction",
    label: "CSC 434",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-434",
  },
  {
    key: 18,
    tooltip: "Advanced Data Communications",
    label: "CSC 435",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-435",
  },
  {
    key: 19,
    tooltip: "Modern Web Development",
    label: "CSC 436",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-436",
  },
  {
    key: 20,
    tooltip: "Mobile Application Development",
    label: "CSC 438",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-438",
  },
  {
    key: 21,
    tooltip: "Microcontrollers",
    label: "CSC 462",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-462",
  },
  {
    key: 22,
    tooltip: "Introductory Computer Graphics",
    label: "CSC 470",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-470",
  },
  {
    key: 23,
    tooltip: "Image Processing in Computer Science",
    label: "CSC 475",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-475",
  },
  {
    key: 24,
    tooltip: "Artificial Intelligence",
    label: "CSC 480",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-480",
  },
  {
    key: 25,
    tooltip: "Discrete Simulation",
    label: "CSC 482",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-482",
  },
  {
    key: 26,
    tooltip: "Theory of Computation",
    label: "CSC 484",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-484",
  },
];

const cscProfileClasses = [
  {
    key: 0,
    tooltip: "Introduction to Computer Science",
    label: "CSC 126",
    url: "https://csicuny.smartcatalogiq.com/current/Undergraduate-Catalog/Courses/CSC-Computer-Science/100/CSC-126",
  },
  {
    key: 1,
    tooltip: "Any 200 level elective",
    label: "200 level elective*",
    url: "https://csicuny.smartcatalogiq.com/en/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-211",
  },
  {
    key: 2,
    tooltip: "Intermediate Programming",
    label: "CSC 211",
    url: "https://csicuny.smartcatalogiq.com/en/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-211",
  },
  {
    key: 3,
    tooltip: "Computers, Networking and Security",
    label: "CSC 220",
    url: "https://csicuny.smartcatalogiq.com/en/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-220",
  },
  {
    key: 4,
    tooltip: "Discrete Mathematical Structures for Computer Science",
    label: "CSC 228",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/200/CSC-228",
  },
  {
    key: 5,
    tooltip: "Introduction to Database Systems",
    label: "CSC 315",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-315",
  },
  {
    key: 6,
    tooltip: "Data Structures",
    label: "CSC 326",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-326",
  },
  {
    key: 7,
    tooltip: "Object-Oriented Software Design",
    label: "CSC 330",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-330",
  },
  {
    key: 8,
    tooltip: "Operating Systems I & Laboratory",
    label: "CSC 332 & 305",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-332",
  },
  {
    key: 9,
    tooltip: "Digital Circuits Design & Laboratory",
    label: "CSC 346 & 347",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-346",
  },
  {
    key: 10,
    tooltip: "Analysis of Algorithms",
    label: "CSC 382",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/300/CSC-382",
  },
  {
    key: 11,
    tooltip: "Any 400 level elective",
    label: "400 level elective*",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-430",
  },
  {
    key: 12,
    tooltip: "Software Engineering",
    label: "CSC 430",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-430",
  },
  {
    key: 13,
    tooltip: "Computer Architecture",
    label: "CSC 446",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-446",
  },
  {
    key: 14,
    tooltip: "Seminar in Computer Science",
    label: "CSC 490",
    url: "https://csicuny.smartcatalogiq.com/Current/Undergraduate-Catalog/Courses/CSC-Computer-Science/400/CSC-490",
  },
];

module.exports = {
  mathClasses,
  cscClasses,
  cscElectives,
  cscProfileClasses,
  mathProfileClasses,
};
